import _classCallCheck from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/esm/createClass";
import { dateISOString, xAmzDate, dateYMD } from "./Date";

var Policy =
/*#__PURE__*/
function () {
  function Policy() {
    _classCallCheck(this, Policy);
  }

  _createClass(Policy, null, [{
    key: "getPolicy",
    value: function getPolicy(config) {
      var policy = function policy() {
        return {
          expiration: dateISOString,
          conditions: [{
            bucket: config.bucketName
          }, ["starts-with", "$key", "".concat(config.dirName ? config.dirName + "/" : "")], {
            acl: "public-read"
          }, ["starts-with", "$Content-Type", ""], {
            "x-amz-meta-uuid": "14365123651274"
          }, {
            "x-amz-server-side-encryption": "AES256"
          }, ["starts-with", "$x-amz-meta-tag", ""], {
            "x-amz-credential": "".concat(config.accessKeyId, "/").concat(dateYMD, "/").concat(config.region, "/s3/aws4_request")
          }, {
            "x-amz-algorithm": "AWS4-HMAC-SHA256"
          }, {
            "x-amz-date": xAmzDate
          }]
        };
      }; //Returns a base64 policy;


      return new Buffer(JSON.stringify(policy())).toString("base64").replace(/\n|\r/, "");
    }
  }]);

  return Policy;
}();

export { Policy as default };
;